<div class="billing-info-dialog-container">
  <div *ngIf="billingForm" class="address-form">
    <form action="" [formGroup]="billingForm">
      <div *ngIf="emailField" class="address">
        <dn-form-input
          placeholder="Email"
          [formGroup]="billingForm"
          [formControlName]="formValues.Email"
        />

      </div>
      <div class="address">
        <dn-form-input
          placeholder="Address"
          [formGroup]="billingForm"
          [formControlName]="formValues.Street"
        />
      </div>

      <div class="country-and-state">
          <dn-menu-input
            [placeholder]="'Country'"
            [form]="billingForm"
            [formControlName]="formValues.Country"
            [menuData]="countries"
            (afterSelect)="onCountrySelect($event)"
          />

        <dn-menu-input
          [placeholder]="'State'"
          [form]="billingForm"
          [formControlName]="formValues.State"
          [menuData]="states"
          [disabled]="!states.length"
        />
      </div>

      <div class="city-and-zip">
        <dn-form-input placeholder="City" [formGroup]="billingForm" [formControlName]="formValues.City" />
        <dn-form-input placeholder="Zip Code" [formGroup]="billingForm" [formControlName]="formValues.ZipCode" />
      </div>
    </form>

  </div>

<!--  <div class="errors" *ngIf="errors">{{errors}}</div>-->
</div>

